module.exports = __webpack_public_path__ + "img/reward-speaker.e128a623.png";